module.exports = __webpack_public_path__ + "img/twohand.b747eb79.png";